import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorRateBar } from "web_myplann/Calculators/Components/CalculatorRateBar";
import type { CalculatorRateBar as CalculatorRateBarType } from "web_myplann/Calculators/Types/CalculatorRateBar";
import type { RateComparisonVariant } from "web_myplann/Calculators/Types/RateComparisonVariant";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	bars: CalculatorRateBarType[];
	intro: string;
	variant: RateComparisonVariant;
};

export const CalculatorRateComparison: FC<Props> = ({
	bars,
	intro,
	variant,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const maxRate = Math.max(...bars.map((bar) => bar.rate ?? 0), 1);

	return (
		<Stack
			mt={theme.spacingTokens.lg}
			pt={theme.spacingTokens.lg}
			borderTop={theme.colors.border.solid(theme.hero.divider)}
		>
			<Typography variant="bodyStrong">
				{t(Resources.Calculators.Result.CompareTitle)}
			</Typography>
			<Typography
				variant="note"
				mt={theme.spacingTokens.xs}
				mb={theme.spacingTokens.md}
			>
				{intro}
			</Typography>
			<Box
				display="grid"
				gridTemplateColumns="max-content 1fr max-content"
				alignItems="center"
				gap={theme.spacingTokens.sm}
			>
				{bars.map((bar) => (
					<CalculatorRateBar
						key={bar.label}
						bar={bar}
						maxRate={maxRate}
						isSubtle={variant === "clientRate"}
					/>
				))}
			</Box>
		</Stack>
	);
};
